module.exports = __webpack_public_path__ + "img/EducationalGroupAttendances.1e2fff04.svg";